module.exports = __webpack_public_path__ + "img/bg_yay.437e23c4.svg";